import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface IOrgCustomBillingUrlEditorProps {
    value: string;
    onUpdate: (field: 'customBillingUrl', value: string) => void;
}

export default function OrgCustomBillingUrlEditor({ value = '', onUpdate }: IOrgCustomBillingUrlEditorProps) {
    const { t } = useTranslation();
    return (
        <TextField
            fullWidth
            label={t('common:organization.orgCustomBillingUrl.title')}
            helperText={t('common:organization.orgCustomBillingUrl.description')}
            value={value}
            placeholder={'-'}
            onChange={(e) => onUpdate('customBillingUrl', e.target.value)}
        />
    );
}
